const Services = () => import('./Services.vue')
const ServiceDetails = () => import('./ServiceDetails.vue')

export default [
  {
    name: 'services',
    path: 'services',
    component: Services,
    meta: {
      access: ['org.service.view']
    },
    children: [
      {
        name: 'service-edit',
        path: ':serviceId/edit',
        components: {
          modal: ServiceDetails
        },
        meta: {
          showModal: true,
          access: ['org.service.manage']
        }
      },
      {
        name: 'service-details',
        path: ':serviceId/view',
        components: {
          modal: ServiceDetails
        },
        meta: {
          showModal: true,
          readOnly: true,
          access: ['org.service.view']
        }
      },
      {
        name: 'service-new',
        path: 'new',
        components: {
          modal: ServiceDetails
        },
        meta: {
          showModal: true,
          access: ['org.service.manage']
        }
      }
    ]
  }
]
